import React, { useEffect } from "react";
import { Spin, Form, Input } from "antd";
import { Button } from "react-bootstrap";
import { LoadingOutlined, ArrowRightOutlined } from "@ant-design/icons";

import { userType } from "../../constant/WebToLead";
import { useRegister } from "./hooks/useRegister";
import {
  handleMobileChange,
  normalizeMobileNumber,
  prefixSelector,
  validateMobileNumber,
} from "../../utils/mobileValidation";

const SignupForm = ({ socialAuth, user, type, oauth2Token }) => {
  const [form] = Form.useForm();
  const { handleCreateAccount, loading, error } = useRegister();

  useEffect(() => {
    form.setFieldsValue(
      user
        ? {
            fullName: user?.firstName + user?.lastName,
            email: user?.email,
            password: null,
            userType: userType.AZURE,
            prefix: "India",
          }
        : {
            fullName: "",
            companyName: "",
            email: "",
            mobileNo: "",
            password: "",
            prefix: "India",
          }
    );
  }, [user, form]);

  return (
    <>
      {error && <p className="text-error text-center pb-2">{error}</p>}

      <Form
        form={form}
        layout="vertical"
        onFinish={(values) =>
          handleCreateAccount(values, user, type, oauth2Token)
        }
      >
        {!socialAuth && (
          <Form.Item
            name="fullName"
            normalize={(value) => value?.replace(/^\s+/, "")}
            rules={[
              { required: true, message: "Please enter your full name." },
            ]}
          >
            <div className="d-flex flex-column">
              <label className="heading12px text-gray pb-1">
                Full Name<span className="text-error">*</span>
              </label>
              <Input
                placeholder="Enter Your Full Name"
                className="auth-input"
              />
            </div>
          </Form.Item>
        )}

        <Form.Item
          name="companyName"
          normalize={(value) => value?.replace(/^\s+/, "")}
          rules={[
            { required: true, message: "Please enter your company name." },
          ]}
        >
          <div className="d-flex flex-column">
            <label className="heading12px text-gray pb-1">
              Company Name<span className="text-error">*</span>
            </label>
            <Input
              placeholder="Enter Your Company Name"
              className="auth-input"
            />
          </div>
        </Form.Item>

        {!socialAuth && (
          <Form.Item
            name="email"
            rules={[
              {
                type: "email",
                message: "Please enter valid E-mail!",
              },
              { required: true, message: "Please enter your email." },
            ]}
          >
            <div className="d-flex flex-column">
              <label className="heading12px text-gray pb-1">
                Email<span className="text-error">*</span>
              </label>
              <Input placeholder="Enter Your Email" className="auth-input" />
            </div>
          </Form.Item>
        )}

        <Form.Item
          name="mobileNo"
          style={{ marginBottom: socialAuth ? 0 : 24 }}
          normalize={normalizeMobileNumber}
          rules={[
            {
              required: true,
              message: "Please enter mobile number",
            },
            {
              validator: validateMobileNumber,
            },
          ]}
        >
          <Input
            placeholder="Enter Your Mobile Number"
            className="mobile-no"
            addonBefore={prefixSelector()}
            maxLength={20}
            onChange={(e) => handleMobileChange(e.target.value, form)}
          />
        </Form.Item>

        {socialAuth && (
          <p className="heading13px text-color-888888">
            This may be used to contact you if you need any assistance
          </p>
        )}

        {!socialAuth && (
          <Form.Item
            name="password"
            rules={[
              { required: true, message: "Please enter password." },
              { min: 4, message: "Password must be at least 4 characters." },
              { max: 100, message: "Password must not exceed 100 characters." },
            ]}
          >
            <div className="d-flex flex-column">
              <label className="heading12px text-gray pb-1">
                Password<span className="text-error">*</span>
              </label>
              <div className="position-relative border-none w-100">
                <Input.Password
                  placeholder="Enter Your Password"
                  className="auth-input w-100"
                  min={4}
                />
              </div>
            </div>
          </Form.Item>
        )}

        <Button
          type="primary"
          htmlType="submit"
          style={{ width: "100%" }}
          className="theme-btn mt-4"
          loading={loading}
        >
          {loading ? (
            <Spin
              indicator={
                <LoadingOutlined
                  style={{
                    color: "#ffffff",
                  }}
                  spin
                />
              }
            />
          ) : (
            <>
              {socialAuth ? (
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{ gap: 10 }}
                >
                  Continue to Dashboard <ArrowRightOutlined />
                </div>
              ) : (
                "Register"
              )}
            </>
          )}
        </Button>
      </Form>
    </>
  );
};

export default SignupForm;
